export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-3e-aecdefd74115041ee35ff04805eb058f.webp";